import api from './api';

export interface Noticia {
  id: number;
  titulo: string;
  slug: string;
  resumo: string;
  corpo: string;
  autor_nome: string;
  status: 'rascunho' | 'publicado';
  publicado_em?: string | null;
  criado_em: string;
  atualizado_em?: string | null;
}

export interface NoticiaForm {
  titulo: string;
  resumo: string;
  corpo: string;
  publicar: boolean;
}

export const noticiaService = {
  async listar(status?: string): Promise<Noticia[]> {
    const params = status ? { status } : {};
    const response = await api.get<Noticia[]>('/api/noticias/', { params });
    return response.data;
  },

  async obter(id: number): Promise<Noticia> {
    const response = await api.get<Noticia>(`/api/noticias/${id}`);
    return response.data;
  },

  async criar(data: NoticiaForm): Promise<Noticia> {
    const response = await api.post<Noticia>('/api/noticias/', data);
    return response.data;
  },

  async atualizar(id: number, data: Partial<NoticiaForm>): Promise<Noticia> {
    const response = await api.put<Noticia>(`/api/noticias/${id}`, data);
    return response.data;
  },

  async excluir(id: number): Promise<void> {
    await api.delete(`/api/noticias/${id}`);
  },

  async uploadImagem(arquivo: File): Promise<{ url: string; filename: string }> {
    const formData = new FormData();
    formData.append('arquivo', arquivo);
    const response = await api.post<{ url: string; filename: string }>(
      '/api/noticias/upload-imagem',
      formData,
      {
        transformRequest: [(data, headers) => {
          if (data instanceof FormData && headers) {
            delete headers['Content-Type'];
          }
          return data;
        }],
      }
    );
    return response.data;
  },
};
